import { FREELANCECANDIDATESECONDARY } from "../../ENVIRONMENT";

// api for freelance secondary list
function freesecondaryList(token) {
  const response = fetch(FREELANCECANDIDATESECONDARY, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
  });
  return response;
}

export { freesecondaryList };
